import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

interface propsTitle {
  data: string;
}
export const ForecastTopo = (params: propsTitle) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          {t("pages.dailyProductionRelease.titlePage")} {params.data}
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default ForecastTopo;
